// extracted by mini-css-extract-plugin
export default {"connection":"styles_connection__9ZvXG","actions":"styles_actions__1QTIs","description":"styles_description__1hyZF","copy":"styles_copy__3KWoF","badge":"styles_badge__q0bdH"};